import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute, useRouter } from '@/router'
import { AppModule } from '@/store/modules/app'
import SidebarItem from './SidebarItem.vue'
import SidebarLogo from './SidebarLogo.vue'
import vars from '@/styles/_variables.scss'
import { VueRouter } from 'vue-router/types/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const router = useRouter() as VueRouter
const sidebar = computed(() => {
  return AppModule.sidebar
})

const routes = computed(() => {
  return router.options.routes
})

const variables = computed(() => {
  return vars
})

const activeMenu = computed(() => {
  const { meta, path } = route.value
  if (meta?.activeMenu) {
    return meta.activeMenu
  }
  return path
})

const isCollapse = computed(() => {
  return !sidebar.value.opened
})

return { __sfc: true,route, router, sidebar, routes, variables, activeMenu, isCollapse, SidebarItem, SidebarLogo }
}

})